export default [
  {
    path: '/cadastros-gerais/estoque',
    name: 'apps-estoque-list',
    component: () => import('@/views/cadastros-gerais/estoque/list/Index.vue'),
    meta: {
      pageTitle: 'Gestão de Estoque',
      breadcrumb: [
        { text: 'Cadastros Gerais', active: false },
        { text: 'Estoque', active: true },
      ],
    },
  },
];
